<template>
    <div class="content">
        <div class="cont">
            <div class="midde devimg"><img class="img" src="../../assets/images/email.png" /></div>
            <!-- <h4 class="midde h4">{{$t('email.h4email')}}</h4>  -->
            <h4 class="midde h4">Lamentamos que nos dejara, por favor elija una opción:</h4>
            <div class="midde foot">
                <!-- <button class="btn yes" @click="show(1)">{{$t('email.yesemail')}}</button> -->
                <button class="btn yes" @click="show(1)">No cambies mis preferencias de suscripción. Todavía quiero recibir correo electrónico</button>
            </div>
            <div class="midde foot">
                <!-- <button class="btn no" @click="show(2)">{{$t('email.noemail')}}</button> -->
                <button class="btn no" @click="show(2)">No quiero recibir un correo electrónico</button>
            </div>
        </div>
        <modal name="address-box" height="auto">
            <div class="modal-close" @click="beforeClose">
                <i class="ion-android-close"></i>
            </div>
            <div id="add-address">
                <loading :show="loginLoading" />
                <div class="container">
                    <el-form :model="ruleForm" label-position="top" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <h4 class="h4">{{$t('email.title')}}</h4>
                        <el-form-item :label="$t('email.title')" prop="useremail">
                            <el-input type="text" class="ipt" v-model="ruleForm.useremail" :placeholder="$t('email.addr')"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="determinar" @click="submitForm('ruleForm')">{{$t('email.Confirm')}}</el-button>
                            <!-- 取消 -->
                            <el-button class="cancelar" @click="beforeClose">{{ $t("email.Clear") }}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </modal>
    </div>
</template>
<style lang="less" scoped>
    .content{
        background: #dae8c0;
        height: 96vh;
        padding: 2vh 0;
        display:flex;
        justify-content:center;
        align-items:center;
    }
    .cont{
        background: #fff;
        border-radius: 10px;
        width: 65%;
        margin: 0 auto;
        padding: 50px 0;
    }
    button {
    white-space: normal;
}
    .h4{
        font-size: 1.4rem;
        height: auto;
        padding: 4px;
    }
    .btn{
        width: 75%;
        height: 80px;
    }
    .yes{
        background: #dae8c0;
        color: #fff;
        margin-bottom: 20px;
    }
    .no{
        background: #686a6c;
        color: #fff;
    }
    .midde{
        text-align: center;
        height: auto;
    }
    .devimg{
        width: 50%;
        margin: 0 auto;
    }
    .img{
        width: 100%;
        display: inline-block;
    }
    .container{
        padding: 20px;
    }
    .h4 {
        height: auto;
        text-align: center;
        font-size: 1.5em;
    }
    .ipt {
        width: 100%;
        border-bottom: 1px #ccc solod;
    }
    .que{
        margin-top: 20px;
    }
    .determinar {
        width: 40%;
        background: #006008;
        color: #e5e5e5;
    }
    .cancelar {
        width: 40%;
        background: #9b9b9b;
        color: #e5e5e5;
    }
</style>
<script>
import loading from '@/views/public/loading.vue'
import { sendemail } from '@/api'

export default {
    data () {
        return {
            type: null,
            ruleForm: {
                useremail: ''
            },
            rules: {
                // 请输入邮箱地址
                useremail: [
                    // 请输入邮箱地址
                    { required: true, message: this.$t('email.addr'), trigger: 'blur' },
                    // 请输入正确的邮箱地址
                    {
                        type: 'email',
                        message: this.$t('forget.emailno'),
                        trigger: ['blur', 'change']
                    }
                ]
            },
            loginLoading: false,
            drawer: false,
        }
    },
    components: {
        loading
    },
    created () {
        
    },
    methods: {
        beforeOpen () { },
        beforeClose () {
            // 恢复默认值
            this.$modal.hide('address-box')
        },
        show (v) {
            console.log('-----', this.$store.state.user.email)
            if (this.$store.state.user.email) {
                this.btnsendemail(this.$store.state.user.email, v);
            } else {
                this.type = v
                this.$modal.show('address-box')
            }
        },
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // eslint-disable-next-line no-console
                    console.log('submitForm---', valid)
                    sendemail({ email: this.ruleForm.useremail,  send_email: this.type}).then(res=>{
                        // eslint-disable-next-line no-console
                        console.log('submitForm --res----', res.data)
                        this.$modal.hide('address-box')
                        if (res.data.status !== 'SUCCESSS') {
                            this.$toasted.error(this.$t('email.errorname'))
                        } else {
                            this.$toasted.success(this.$t('email.success'))
                        }
                    })
                } else {
                    console.log('error submit!!', valid)
                    return false
                }
            })
        },
        btnsendemail(e, v) {
            let type, message
            if (v==1) {
                type = 'success'
                message = this.$t('email.yesbtn')
            } else if (v==2) {
                type = 'error'
                message = this.$t('email.nobtn')
            }
            this.$confirm(message, {
                confirmButtonText: this.$t('User.ConfirmButtonText'),
                cancelButtonText: this.$t('User.CancelButtonText'),
                type: type
            }).then(_r => {
                // eslint-disable-next-line no-console
                console.log('success-----', { email: e,  send_email: v},_r)
                sendemail({ email: e,  send_email: v}).then(res=>{
                    // eslint-disable-next-line no-console
                    console.log('----', res.data)
                    if (res.data.status !== 'SUCCESSS') {
                        this.$toasted.error(this.$t('email.errorname'))
                    } else {
                        this.$toasted.success(this.$t('email.success'))
                    }
                })
            }).catch(err => { })
        }
    }
}
</script>
